/**
 * illm-common.js
 * Version: 1.0.0
 */

var illm = { common:{} };

/**
 * PC判定
 */
illm.common.isPC = function() {
  return $(window).width() > 749;
}

/**
 * 現在のページのURLを取得(絶対パス)
 */
illm.common.getCurrentUrl = function() {
  return `${document.location.protocol}//${document.location.host}${document.location.pathname}`;
}

/**
 * HOMEのURLを取得（pathnameからの絶対パス）
 */
illm.common.getHomeUrlPathName = () => '/';

/**
 * HOMEのURLを取得(絶対パス)
 */
illm.common.getHomeUrl = function() {
  const pathname = illm.common.getHomeUrlPathName();
  return `${document.location.protocol}//${document.location.host}${pathname}`;
}

/**
 * トップページ判定
 */
illm.common.isPageTop = function() {
  return Util.isPageRegex('^/\/?$');
}

/**
 * 現在時刻をサーバーから取得
 */
illm.common.getServerDate = function() {
  const url = window.location.href;
  return fetch( url )
  .then(res => {
    if (!res.ok) throw new Error( 'fetch failed' );
    // レスポンスヘッダーから時刻を取得
    return new Date( res.headers.get('Date') );
  })
  .catch(error => {
    // エラー時はブラウザの現在時刻を返す
    return new Date();
  });
}

/**
 * スムーススクロール
 */
illm.common.smoothScroll = function( speed ) {
  //スクロールの速さの指定がない場合は、固定で600ms指定
  if( typeof speed === 'undefined' ){
    speed = 600;
  }
  
  //ページ内リンクをクリックしたら、該当の場所にスムーズにスクロール
  $( 'a[href^="#"]' ).on( 'click', function () {
    const href = $( this ).attr( 'href' );
    const target = $( href == '#' || href == '' ? 'html' : href );
    const position = target.offset().top;
    $( 'body, html' ).animate( { scrollTop: position }, speed, 'swing' );
    return false;
  });
}
